<div class="popup-overlay" (click)="ok()"></div>
<div class="popup-box" role="dialog" aria-labelledby="popup-title">
  <h2 id="popup-title" class="invitation-title">{{ invitationService.config.title }}</h2>
  <p class="invitation-message">{{ invitationService.config.shortMessage }}</p>

  <div class="invitation-links">
    <a
      class="eventbrite-link"
      [href]="invitationService.config.eventbrite.url"
      target="_blank"
      rel="noopener noreferrer"
      (click)="$event.stopPropagation()">
      <mat-icon>open_in_new</mat-icon>
      {{ invitationService.config.eventbrite.label }}
    </a>

    <div class="pdf-links-label">Documentos (PDF)</div>
    <a
      *ngFor="let pdf of invitationService.getInvitationPdfItems()"
      class="pdf-link"
      [href]="pdf.url"
      rel="noopener noreferrer"
      (click)="invitationService.openPdfPreviewAndDownload($event, pdf.url, pdf.downloadFileName)">
      <mat-icon>picture_as_pdf</mat-icon>
      {{ pdf.label }}
    </a>
  </div>

  <div class="popup-actions">
    <button type="button" class="btn-popup-ok" (click)="ok()">OK</button>
  </div>
</div>
